<script>
import BillingAccountDetails from '~/javascripts/billing_account/components/billing_account_details.vue';
import CustomerFields from './customer_fields.vue';

export default {
  name: 'CustomerInformation',
  components: {
    CustomerFields,
    BillingAccountDetails,
  },
  inject: {
    customerBillingAccountsPresent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<template>
  <section>
    <billing-account-details v-if="customerBillingAccountsPresent" />
    <customer-fields v-else />
  </section>
</template>
